import { Product } from "@towersystems/roam-common/lib/generated-types";
import ProductModel from "./data/model/Product";
import { ProductThumbnailProps } from "@towersystems/roam-common-native";

export const toInternalProductType = (
  product: Product | ProductModel
): ProductThumbnailProps["internalProductType"] | undefined => {
  if (!product?.internal) {
    return undefined;
  }
  switch (product.stockCode) {
    case "SUSUSUSU":
      return "SURCHARGE";
    case "GIFTCARD":
      return "GIFT_CARD";
    case "CPCPCPCP":
      return "PROFORMA";
  }

  return undefined;
};
